import React from "react";
import TrialCta from "../../../../common/components/TrialCta";
import PageBanner from "../../../../common/components/PageBanner";
import banner from "../../../../assets/new-images/banner 3 why our role matters(2).png";
import "../styles/Aboutus.css";

// "Why Planning Matters" (was "Why Our Roles Matters"). Route stays /aboutUs/our-roles.
const OurRolesComponent = () => (
  <div>
    <PageBanner
      image={banner}
      alt="A firefighter guiding a prepared family carrying go-bags to safety during a night storm."
      eyebrow="About Us / Why Planning Matters"
      title="Why Planning Matters"
    />
    <section className="mrf-section">
      <div className="mrf-container" style={{ maxWidth: 880 }}>
        <p className="mrf-callout">
          Emergencies can separate family members, interrupt communications, and make important information hard to
          find. A household plan answers useful questions beforehand: Who checks on whom? Where will we meet? What should
          we take? Where are our records?
        </p>
        <p className="mrf-body" style={{ fontSize: 18 }}>
          MYREDFOLDER® helps families work through those answers and keep their plan together. Start with one
          conversation, then build and practice the plan.
        </p>
        <div style={{ marginTop: 28 }}>
          <TrialCta liveLabel="Build your family plan" fallbackLabel="Build your family plan" />
        </div>
      </div>
    </section>
  </div>
);

export default OurRolesComponent;
